import { Grid2, Typography } from "@mui/material"
import ManagerWebViewStyles from "./Web.module.css"
import Jitesh from "../../../ui-utils/latestPics/Jitesh.png"
import Pooja from "../../../ui-utils/latestPics/Pooja.png"
import Dubey from "../../../ui-utils/latestPics/Dubey.jpg"
import Prashant from "../../../ui-utils/latestPics/Prashant1.jpeg"
import Manish from "../../../ui-utils/latestPics/Manish1.png"
import { fontFamily, padding } from "@mui/system"
import { useRef } from 'react';
import en from "../../../i18n/English/Aboutus/management.json";
import hi from "../../../i18n/Hindi/Aboutus/management.json";
import kn from "../../../i18n/Kannada/Aboutus/management.json";
import ma from "../../../i18n/Marathi/Aboutus/management.json";
import gu from "../../../i18n/Gujarati/Aboutus/management.json";
import { useLanguage } from "../../../Context/LangContext";

export default function WebManagement() {
    const backRef1 = useRef(null);
    const backRef2 = useRef(null);
    const backRef3 = useRef(null);
    const backRef4 = useRef(null);
    const backRef5 = useRef(null);
         const { language } = useLanguage();
         const translations = { en, hi, kn,gu,ma };
       const t = translations[language] || translations.en ;
    return (
        <>

                <Grid2 className={ManagerWebViewStyles.outerCard}>
                    <Grid2 className={ManagerWebViewStyles.title_card}>
                        {/* <h1 className={ManagerWebViewStyles.leader_title}>{t.heading}</h1> */}
                    <div className={ManagerWebViewStyles.headingContainer}>
                        <div className={ManagerWebViewStyles.gradientBackground}></div>
                        <h1 className={ManagerWebViewStyles.leader_title} style={{ fontWeight: 600 }}>
                            {t.heading}
                        </h1>
                    </div>
                    </Grid2>



                    <Grid2 className={ManagerWebViewStyles.inner_card}>



                        <Grid2
                            className={ManagerWebViewStyles.flip_card}
                            onMouseEnter={() => {
                                if (backRef1.current) {
                                    backRef1.current.scrollTop = 0;
                                }
                            }}
                        >
                            <Grid2 className={ManagerWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_front}>
                                    <img src={Jitesh} alt="leaderpic" className={ManagerWebViewStyles.picture} />
                                    <Grid2>
                                    <Typography className={ManagerWebViewStyles.ex_subtit}>{t.management[0].name}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit1}>{t.management[0].designation}</Typography>
                                    </Grid2>
                                </Grid2>

                                {/* Back Side */}
                                <Grid2
                                    className={ManagerWebViewStyles.flip_card_back1}

                                >
                                <div className={ManagerWebViewStyles.flip_back_content} ref={backRef1} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                <Typography className={ManagerWebViewStyles.ex_subtitback}>{t.management[0].name}</Typography>
                                <Typography className={ManagerWebViewStyles.ex_subtit1back}>{t.management[0].designation}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit2}>
                                    <span className={ManagerWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[0].name}</span>
                                    {t.management[0].description}

                                    </Typography>
                                    </div>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        {/* Card 2 */}
                        <Grid2 className={ManagerWebViewStyles.flip_card}
                            onMouseEnter={() => {
                                if (backRef2.current) {
                                    backRef2.current.scrollTop = 0;
                                }
                            }}>
                            <Grid2 className={ManagerWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_front}>
                                    <img src={Pooja} alt="leaderpic" className={ManagerWebViewStyles.picture} />

                                    <Grid2>
                                    <Typography className={ManagerWebViewStyles.ex_subtit}>{t.management[1].name}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit1}>{t.management[1].designation}</Typography>
                                    </Grid2>

                                </Grid2>
                                {/* Back Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_back1} >
                                <div className={ManagerWebViewStyles.flip_back_content} ref={backRef2} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                <Typography className={ManagerWebViewStyles.ex_subtitback}>{t.management[1].name}</Typography>
                                <Typography className={ManagerWebViewStyles.ex_subtit1back}>{t.management[1].designation}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit2}>
                                    <span className={ManagerWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[1].name}</span>   {t.management[1].description}
                                    </Typography>
                                    </div>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        {/* Card 3 */}



                    </Grid2>


                    <Grid2 className={ManagerWebViewStyles.inner_card} sx={{
                        marginTop:"120px"
                    }}>



                        <Grid2 className={ManagerWebViewStyles.flip_card}
                            onMouseEnter={() => {
                                if (backRef3.current) {
                                    backRef3.current.scrollTop = 0;
                                }
                            }}>
                            <Grid2 className={ManagerWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_front}>
                                    <img src={Dubey} alt="leaderpic" className={ManagerWebViewStyles.picture} />
                                    <Grid2>
                                    <Typography className={ManagerWebViewStyles.ex_subtit}>{t.management[2].name}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit1} style={{width:"250px"}} >{t.management[2].designation}</Typography>
                                    </Grid2>

                                    {/* <Typography  className={`${ManagerWebViewStyles.ex_subtit2}`}>
                    Mr. Shetty is a seasoned professional,
                    possessing over more than four decades of
                    experience in the Indian Stock Market as well
                    as Financial Markets.
                </Typography> */}
                                </Grid2>
                                {/* Back Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_back1} >
                                <div className={ManagerWebViewStyles.flip_back_content} ref={backRef3} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                <Typography className={ManagerWebViewStyles.ex_subtitback}>{t.management[2].name}</Typography>
                                <Typography className={ManagerWebViewStyles.ex_subtit1back}>{t.management[2].designation}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit2}>
                                    <span className={ManagerWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[2].name}</span>{t.management[2].description}
                                    </Typography>
                                </div>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        {/* Card 2 */}
                        <Grid2 className={ManagerWebViewStyles.flip_card}
                            onMouseEnter={() => {
                                if (backRef4.current) {
                                    backRef4.current.scrollTop = 0;
                                }
                            }}>
                            <Grid2 className={ManagerWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_front}>
                                    <img src={Prashant} alt="leaderpic" className={ManagerWebViewStyles.picture} />

                                    <Grid2>
                                    <Typography className={ManagerWebViewStyles.ex_subtit}>{t.management[3].name}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit1}>{t.management[3].designation}</Typography>
                                    </Grid2>

                                </Grid2>
                                {/* Back Side */}
                                <Grid2 className={ManagerWebViewStyles.flip_card_back} >
                                <div className={ManagerWebViewStyles.flip_back_content} ref={backRef4} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                <Typography className={ManagerWebViewStyles.ex_subtitback}>{t.management[3].name}</Typography>
                                <Typography className={ManagerWebViewStyles.ex_subtit1back}>{t.management[3].designation}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit2}>
                                    <span className={ManagerWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[3].name}</span>  {t.management[3].description}
                                    </Typography>
                                </div>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        {/* Card 3 */}
                        {/* <Grid2 className={ManagerWebViewStyles.flip_card}>
        <Grid2 className={ManagerWebViewStyles.flip_card_inner}>

            <Grid2 className={ManagerWebViewStyles.flip_card_front}>
                <img src={Roshni} alt="leaderpic" className={ManagerWebViewStyles.picture} />
                <Typography className={ManagerWebViewStyles.ex_subtit}>Ms. Roshni Shetty</Typography>
                <Typography className={ManagerWebViewStyles.ex_subtit1}>Director</Typography>
            </Grid2>

            <Grid2 className={ManagerWebViewStyles.flip_card_back}>
                <Typography className={ManagerWebViewStyles.ex_subtit2}>
                    Ms. Roshni Shetty is possessing over two
                    decades of experience in the Indian Stock
                    Market as well as Financial Markets.
                </Typography>
            </Grid2>
        </Grid2>
    </Grid2> */}


                    </Grid2>


                <Grid2 className={ManagerWebViewStyles.inner_card} sx={{
                    marginTop: "120px"
                }}>



                    <Grid2 className={ManagerWebViewStyles.flip_card}
                        onMouseEnter={() => {
                            if (backRef5.current) {
                                backRef5.current.scrollTop = 0;
                            }
                        }}>
                        <Grid2 className={ManagerWebViewStyles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={ManagerWebViewStyles.flip_card_front}>
                                <img src={Manish} alt="leaderpic" className={ManagerWebViewStyles.picture} />
                                <Grid2>
                                    <Typography className={ManagerWebViewStyles.ex_subtit}>{t.management[4].name}</Typography>
                                    <Typography className={ManagerWebViewStyles.ex_subtit1} style={{ width: "250px" }} >{t.management[4].designation}</Typography>
                                </Grid2>

                                {/* <Typography  className={`${ManagerWebViewStyles.ex_subtit2}`}>
                    Mr. Shetty is a seasoned professional,
                    possessing over more than four decades of
                    experience in the Indian Stock Market as well
                    as Financial Markets.
                </Typography> */}
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={ManagerWebViewStyles.flip_card_back1} >
                                <div className={ManagerWebViewStyles.flip_back_content} ref={backRef5} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                <Typography className={ManagerWebViewStyles.ex_subtitback}>{t.management[4].name}</Typography>
                                <Typography className={ManagerWebViewStyles.ex_subtit1back}>{t.management[4].designation}</Typography>
                                <Typography className={ManagerWebViewStyles.ex_subtit2}>
                                    <span className={ManagerWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[4].name}</span>{t.management[4].description}
                                </Typography>
                               </div>
                            </Grid2>
                        </Grid2>
                    </Grid2>





                </Grid2>


                </Grid2>

        </>
    )
}